import { all, fork } from 'redux-saga/effects';
import list from './list';
import info from './info';

export default function* events() {
  yield all([fork(list), fork(info)]);
}
